import React from 'react';
import PropTypes from 'prop-types';
import withMetrics from '@nib/with-metrics';
import mapMetricsToPropsFactories from './mapMetricsToProps';

const mapMetricsToProps = ({ pageView }) => ({
  pageView
});

export const findPropsSelectFunc = arg => {
  const found = mapMetricsToPropsFactories.find(f => f(arg));
  if (found) return found(arg);
  return () => {
    throw new Error(`Invalid value of type ${typeof arg}. Expecting: object or function`);
  };
};

export const trackedPageViewComponentFactory = (WrappedPage, getProps) => {
  class TrackedPageView extends React.Component {
    componentDidMount() {
      this.props.pageView(getProps(this.props));
    }

    render() {
      const { pageView, ...otherProps } = this.props; //eslint-disable-line
      return <WrappedPage {...otherProps} />;
    }
  }

  TrackedPageView.propTypes = {
    pageView: PropTypes.func.isRequired
  };
  return TrackedPageView;
};

export default function(WrappedPage, props) {
  const propsSelectFunc = findPropsSelectFunc(props);
  const TrackedPage = trackedPageViewComponentFactory(WrappedPage, propsSelectFunc);
  return withMetrics(mapMetricsToProps)(TrackedPage);
}
